import React from 'react';
import data2 from '../../../data/skills2.json';
import data from '../../../data/skills.json';
function Skills() {
  return (
    <div
      className="sec-box skills section-padding bord-thin-bottom"
      id="skills"
    >
      <div className="row">
        <div className="col-lg-4 valign">
          <div className="sec-head md-mb80 wow fadeIn">
            <h3>
              <span className="main-color">Skills, Awards,</span> & <br/>Certificates 
            </h3>
          </div>
        </div>
        <div className="col-lg-8">
          <div className="row ">
            {data.map((item, index) => (
              <div key={index} className="col-md-4">
                <div className="item mb-10 ">
                  <div className="d-flex align-items-center mb-30">
                    <div className="mr-10">
                      <div className="img icon-img-40">
                        <img src={item.photo} alt="" />
                      </div>
                    </div>  
                    <div>
                      <h6 className="fz-18">{item.title}</h6>
                    </div>
                  </div>
                  <div className="skill-progress">
                    <span className="progres" data-value={item.persent}></span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="awards mt-100">
        <div className="row md-marg">
          {data2.map((item, index) => (
            <div key={index} className="col-lg-4 mt-30">
              <div
                className="award-item sub-bg md-mb30 wow fadeInUp"
                data-wow-delay=".2s"
              >
                <div className="d-flex">
                  
                  <div className="ml-auto">
                    <span>{item.year}</span>
                  </div>
                </div>
                <div className="img icon-img-150 mt-500 mb-40">
                  <img src={item.photo} alt="" />
                </div>
                <h6>{item.name}</h6>
                <span className="sub-title main-color mt-10">{item.title}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Skills;
